//@flow

import React from "react"
import { Route, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { FormattedMessage } from "react-intl"
import styled from "styled-components"
import { logoutUser } from "../Auth"
import Home from "../Home"
import Kiosks from "../Kiosks"
import Sensors from "../Sensors"
import Users from "../Users"
import { Sidebar, Nav, NavLink, NavSpacer, Icon } from "../UI/Sidebar"
import { Container, Content } from "../UI/Page"
import { networkAvailable } from "../Network"
import { currentLocale, setLocale, LOCALE_EN, LOCALE_ES } from "../Intl"
import { H4 } from "../UI/Headings"
import { Flash } from "../UI/Flash"

import type { Locale } from "../Intl"

type RouteDetail = {
  icon?: string,
  name?: string,
  path?: string,
  exact?: boolean,
  component?: any,
  localeSelector?: (
    currentLocale: Locale,
    onSelect: (locale: Locale) => any
  ) => React$Element<*>,
  spacer?: boolean
}

const LanguageMenu = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 1rem;
`

const LanguageOption = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  text-align: center;
  background: ${({ active }: { active: boolean }) =>
    active ? "rgba(255,255,255,1)" : "transparent"};
  padding: 0.5rem;
  border-radius: 2rem;
`

const LanguageIcon = Icon.extend`
  padding: 0;
  margin: auto;
`

const routes: Array<RouteDetail> = [
  {
    icon: "🏠",
    name: "Home",
    path: "/admin",
    exact: true,
    component: Home
  },
  {
    icon: "🖥",
    name: "Kiosks",
    path: "/admin/kiosks",
    exact: false,
    component: Kiosks
  },
  {
    icon: "🛰",
    name: "Sensors",
    path: "/admin/sensors",
    exact: false,
    component: Sensors
  },
  {
    icon: "👥",
    name: "Users",
    path: "/admin/users",
    exact: false,
    component: Users
  },
  { spacer: true },
  {
    localeSelector: (
      currentLocale: Locale,
      onClick: (locale: Locale) => any
    ) => (
      <LanguageMenu key="language">
        {[
          { icon: "🇺🇸", locale: LOCALE_EN },
          { icon: "🇲🇽", locale: LOCALE_ES }
        ].map(locale => (
          <LanguageOption
            key={`admin.nav.language.${locale.locale}`}
            active={locale.locale === currentLocale}
            onClick={() => onClick(locale.locale)}
          >
            <LanguageIcon>{locale.icon}</LanguageIcon>
          </LanguageOption>
        ))}
      </LanguageMenu>
    )
  },
  {
    icon: "🚪",
    name: "Logout",
    path: "/admin/logout",
    exact: false,
    component: () => {
      logoutUser()
      return <Redirect to="/" />
    }
  }
]

const AdminView = ({
  networkAvailable,
  currentLocale,
  setLocale,
  ...props
}) => (
  <Container>
    <Sidebar>
      <Nav>
        {routes.map(
          (route, index) =>
            route.localeSelector ? (
              route.localeSelector(currentLocale, locale => setLocale(locale))
            ) : route.spacer ? (
              <NavSpacer key={`spacer${index}`} />
            ) : (
              <NavLink
                to={route.path}
                pathname={props.location.pathname}
                key={route.name}
                exact={route.exact}
              >
                <Icon aria-label={route.name}>{route.icon}</Icon>
                <FormattedMessage
                  id={`admin.nav.${route.name
                    ? route.name.toLocaleLowerCase()
                    : ""}`}
                />
              </NavLink>
            )
        )}
      </Nav>
    </Sidebar>
    <Content>
      {!networkAvailable ? (
        <Flash>
          <H4>You are currently offline.</H4>
        </Flash>
      ) : (
        ""
      )}
      {routes.map(
        (route, index) =>
          route.spacer || route.render ? null : (
            <Route
              path={route.path}
              component={route.component}
              exact={route.exact}
              key={`route-${route.name ? route.name : ""}`}
            />
          )
      )}
    </Content>
  </Container>
)

export default connect(
  state => ({
    networkAvailable: networkAvailable(state),
    currentLocale: currentLocale(state)
  }),
  {
    setLocale
  }
)(AdminView)



// WEBPACK FOOTER //
// ./src/Admin/AdminView.js